import { TrendingUp, Copy } from 'lucide-react'
import { useState } from 'react'

export default function KeywordsTable({ keywords, source }) {
  const [copied, setCopied] = useState(null)
  const isTrends = source === 'google_trends'

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
    setCopied(text)
    setTimeout(() => setCopied(null), 2000)
  }

  if (!keywords || keywords.length === 0) return null

  const sourceLabel = source === 'google-ads-keyword-planner'
    ? 'Google Ads Keyword Planner'
    : source === 'dataforseo'
    ? 'DataForSEO'
    : source === 'google_trends'
    ? 'Google Trends'
    : null

  return (
    <div className="gradient-glow p-6 rounded-xl card-hover">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <TrendingUp className="w-6 h-6 text-[#94a3b8]er" />
          <h3 className="text-xl font-bold text-white">Keywords Rentables</h3>
        </div>
        {sourceLabel && (
          <span className="text-xs text-[#94a3b8] bg-slate-darker px-2 py-1 rounded-md border border-slate-light/20">
            {sourceLabel}
          </span>
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-slate-light/20">
              <th className="text-left py-3 px-4 text-[#94a3b8] font-semibold text-sm">Palabra Clave</th>
              <th className="text-center py-3 px-4 text-[#94a3b8] font-semibold text-sm">
                {isTrends ? 'Interés' : 'Volumen'}
              </th>
              {!isTrends && (
                <th className="text-center py-3 px-4 text-[#94a3b8] font-semibold text-sm">CPC</th>
              )}
              <th className="text-center py-3 px-4 text-[#94a3b8] font-semibold text-sm">Rentabilidad</th>
              <th className="text-center py-3 px-4 text-[#94a3b8] font-semibold text-sm">Acción</th>
            </tr>
          </thead>
          <tbody>
            {keywords.map((keyword, idx) => (
              <tr
                key={idx}
                className="border-b border-slate-light/10 hover:bg-slate-darker/50 transition-all"
              >
                <td className="py-4 px-4 text-white font-semibold">{keyword.term}</td>
                <td className="py-4 px-4 text-center">
                  <span className="text-[#94a3b8] font-bold">
                    {keyword.volume != null ? keyword.volume.toLocaleString() : '—'}
                  </span>
                  <p className="text-xs text-slate-medium">{isTrends ? '/100' : '/mes'}</p>
                </td>
                {!isTrends && (
                  <td className="py-4 px-4 text-center">
                    <span className="text-[#94a3b8]er font-bold">
                      {keyword.cpc != null ? `$${keyword.cpc.toFixed(2)}` : '—'}
                    </span>
                  </td>
                )}
                <td className="py-4 px-4">
                  <div className="flex items-center justify-center gap-2">
                    <div className="flex-1">
                      <div className="relative h-2 bg-slate-medium rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-slate-lighter to-slate-light rounded-full"
                          style={{ width: `${keyword.profitability}%` }}
                        ></div>
                      </div>
                    </div>
                    <span className="text-sm font-bold text-[#94a3b8]er w-8 text-right">{keyword.profitability}%</span>
                  </div>
                </td>
                <td className="py-4 px-4 text-center">
                  <button
                    onClick={() => handleCopy(keyword.term)}
                    className="p-2 hover:bg-slate-light/20 rounded-lg transition-all"
                    title="Copiar"
                  >
                    {copied === keyword.term ? (
                      <span className="text-xs text-[#94a3b8]er">✓ Copiado</span>
                    ) : (
                      <Copy className="w-4 h-4 text-[#94a3b8] hover:text-[#94a3b8]er" />
                    )}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 p-4 bg-slate-darker rounded-lg border border-slate-light/20">
        <p className="text-sm text-slate-300">
          <span className="font-semibold text-[#94a3b8]">💡 Uso de Keywords:</span>{' '}
          {isTrends
            ? 'Términos reales de búsqueda de Google Trends. El interés (0-100) indica popularidad relativa.'
            : 'Términos de búsqueda con volumen mensual real y CPC. Prioriza los de mayor rentabilidad.'}
        </p>
      </div>
    </div>
  )
}
